import React from 'react';

const DiwaliBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      {/* Sacred Golden Ambient Glow */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 80% 15%, rgba(245, 158, 11, 0.22) 0%, rgba(220, 38, 38, 0.14) 35%, transparent 65%), radial-gradient(circle at 20% 85%, rgba(245, 158, 11, 0.16) 0%, rgba(139, 92, 246, 0.12) 40%, transparent 65%)'
        }}
      />

      <svg
        viewBox="0 0 1600 1000"
        className="w-full h-full object-cover"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="palaceGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#2E1107" />
            <stop offset="100%" stopColor="#140602" />
          </linearGradient>
          <linearGradient id="diyaGlow" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFFBEB" />
            <stop offset="40%" stopColor="#FBBF24" />
            <stop offset="80%" stopColor="#F97316" />
            <stop offset="100%" stopColor="#DC2626" />
          </linearGradient>
          <filter id="diyaHalo" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
          </filter>
        </defs>

        {/* Floating Sky Lanterns (Kandils) ascending to heaven */}
        <g opacity="0.85">
          <circle cx="280" cy="180" r="14" fill="#F59E0B" filter="url(#diyaHalo)" opacity="0.5" />
          <polygon points="280,172 288,188 272,188" fill="#FDE68A" />

          <circle cx="420" cy="110" r="11" fill="#F97316" filter="url(#diyaHalo)" opacity="0.5" />
          <polygon points="420,104 426,116 414,116" fill="#FDE68A" />

          <circle cx="750" cy="150" r="16" fill="#F59E0B" filter="url(#diyaHalo)" opacity="0.6" />
          <polygon points="750,140 760,160 740,160" fill="#FEF08A" />

          <circle cx="920" cy="90" r="10" fill="#EF4444" filter="url(#diyaHalo)" opacity="0.4" />
          <polygon points="920,85 925,95 915,95" fill="#FDE68A" />

          <circle cx="1180" cy="130" r="15" fill="#F59E0B" filter="url(#diyaHalo)" opacity="0.5" />
          <polygon points="1180,122 1188,138 1172,138" fill="#FEF08A" />

          <circle cx="1380" cy="190" r="13" fill="#F97316" filter="url(#diyaHalo)" opacity="0.5" />
          <polygon points="1380,183 1387,197 1373,197" fill="#FDE68A" />
        </g>

        {/* Majestic Indian Palace Architecture Silhouette */}
        <g fill="url(#palaceGrad)">
          {/* Left Palace Complex with Chhatris & Domes */}
          <rect x="0" y="620" width="480" height="380" />
          {/* Main Dome */}
          <path d="M120 620 C120 520 200 480 200 460 C200 480 280 520 280 620 Z" />
          <polygon points="196,460 204,460 200,430" fill="#F59E0B" />
          {/* Side Chhatri */}
          <path d="M340 620 C340 560 380 540 380 525 C380 540 420 560 420 620 Z" />
          <polygon points="378,525 382,525 380,505" fill="#F59E0B" />

          {/* Right Palace Complex */}
          <rect x="1120" y="620" width="480" height="380" />
          <path d="M1320 620 C1320 520 1400 480 1400 460 C1400 480 1480 520 1480 620 Z" />
          <polygon points="1396,460 1404,460 1400,430" fill="#F59E0B" />
          <path d="M1180 620 C1180 560 1220 540 1220 525 C1220 540 1260 560 1260 620 Z" />
          <polygon points="1218,525 1222,525 1220,505" fill="#F59E0B" />
        </g>

        {/* Glowing Jali Arch Windows with Warm Temple Illumination */}
        <g fill="#FEF08A" opacity="0.8">
          <path d="M180 560 C180 540 190 530 200 530 C210 530 220 540 220 560 L220 590 L180 590 Z" />
          <path d="M365 570 C365 555 372 550 380 550 C388 550 395 555 395 570 L395 595 L365 595 Z" />
          <path d="M1380 560 C1380 540 1390 530 1400 530 C1410 530 1420 540 1420 560 L1420 590 L1380 590 Z" />
          <path d="M1205 570 C1205 555 1212 550 1220 550 C1228 550 1235 555 1235 570 L1235 595 L1205 595 Z" />
        </g>

        {/* Terrace Parapet Row of Sacred Glowing Diyas */}
        {[80, 160, 240, 320, 400, 480, 560, 640, 720, 800, 880, 960, 1040, 1120, 1200, 1280, 1360, 1440, 1520].map((x, idx) => (
          <g key={idx} transform={`translate(${x}, 610)`}>
            {/* Diya Flame Ambient Aura */}
            <circle cx="0" cy="-6" r="14" fill="#F59E0B" fillOpacity="0.35" filter="url(#diyaHalo)" />
            {/* Terracotta Diya Clay Bowl */}
            <path d="M-10,0 C-10,6 10,6 10,0 Z" fill="#92400E" stroke="#B45309" strokeWidth="1" />
            {/* Dancing Sacred Flame */}
            <path d="M-3,-1 C-5,-7 0,-14 0,-14 C0,-14 5,-7 3,-1 Z" fill="url(#diyaGlow)" />
          </g>
        ))}

        {/* Foreground Palace Terrace Border */}
        <path d="M0 720 Q800 680 1600 720 L1600 1000 L0 1000 Z" fill="#1C0A04" />
        <path d="M0 820 Q800 790 1600 820 L1600 1000 L0 1000 Z" fill="#110502" />
      </svg>
    </div>
  );
};

export default DiwaliBackgroundGraphics;
